// Pinboard color themes and translations

export const noteColors = {
  yellow: {
    bg: 'bg-yellow-100',
    border: 'border-yellow-300',
    shadow: 'shadow-yellow-200/50',
    ring: 'ring-yellow-400',
    label: { de: 'Gelb', en: 'Yellow' }
  },
  pink: {
    bg: 'bg-pink-100',
    border: 'border-pink-300',
    shadow: 'shadow-pink-200/50',
    ring: 'ring-pink-400',
    label: { de: 'Pink', en: 'Pink' }
  },
  blue: {
    bg: 'bg-blue-100',
    border: 'border-blue-300',
    shadow: 'shadow-blue-200/50',
    ring: 'ring-blue-400',
    label: { de: 'Blau', en: 'Blue' }
  },
  green: {
    bg: 'bg-green-100',
    border: 'border-green-300',
    shadow: 'shadow-green-200/50',
    ring: 'ring-green-400',
    label: { de: 'Grün', en: 'Green' }
  },
  orange: {
    bg: 'bg-orange-100',
    border: 'border-orange-300',
    shadow: 'shadow-orange-200/50',
    ring: 'ring-orange-400',
    label: { de: 'Orange', en: 'Orange' }
  }
};

export const texts = {
  de: {
    title: 'Meine Pinwand',
    addNote: 'Notiz hinzufügen',
    newNote: 'Neue Notiz',
    editNote: 'Notiz bearbeiten',
    placeholder: 'Was möchtest du dir merken?',
    categoryPlaceholder: 'Kategorie (optional)',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    fromProject: 'Aus Projekt',
    noNotes: 'Keine Notizen vorhanden. Füge deine erste Notiz hinzu!',
    color: 'Farbe',
    category: 'Kategorie',
    dragHint: 'Ziehen zum Verschieben',
    archive: 'Archiv',
    markDone: 'Erledigt',
    restore: 'Wiederherstellen',
    noArchived: 'Keine archivierten Notizen',
    archivedNotes: 'Archivierte Notizen',
    addImage: 'Bild hinzufügen',
    removeImage: 'Bild entfernen',
    imageHint: 'Max. 200KB',
    swipeHint: 'Wischen für andere Pinwände',
    newBoard: 'Neue Pinwand',
    boardName: 'Name der Pinwand',
    boards: 'Pinwände',
    deleteBoard: 'Pinwand löschen',
    cannotDeleteDefault: 'Standard-Pinwand kann nicht gelöscht werden',
    content: 'Inhalt',
    dialogDescription: 'Verwalte deine Notizen und Aufgaben auf dieser Pinwand.'
  },
  en: {
    title: 'My Pinboard',
    addNote: 'Add Note',
    newNote: 'New Note',
    editNote: 'Edit Note',
    placeholder: 'What do you want to remember?',
    categoryPlaceholder: 'Category (optional)',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    fromProject: 'From Project',
    noNotes: 'No notes yet. Add your first note!',
    color: 'Color',
    category: 'Category',
    dragHint: 'Drag to move',
    archive: 'Archive',
    markDone: 'Done',
    restore: 'Restore',
    noArchived: 'No archived notes',
    archivedNotes: 'Archived Notes',
    addImage: 'Add Image',
    removeImage: 'Remove Image',
    imageHint: 'Max. 200KB',
    swipeHint: 'Swipe for other boards',
    newBoard: 'New Board',
    boardName: 'Board Name',
    boards: 'Boards',
    deleteBoard: 'Delete Board',
    cannotDeleteDefault: 'Cannot delete default board',
    content: 'Content',
    dialogDescription: 'Manage your notes and tasks on this pinboard.'
  }
};

export const getText = (key, language = 'de') => {
  return texts[language]?.[key] || texts.de[key];
};
